import TabsNavigation from './TabsNavigation.component';

export default TabsNavigation;
